import * as XLSX from 'xlsx';
import { readFileAsArrayBuffer } from '../file';
import Workbook from './workbook';

/**
 * @param {Blob} blob
 * @returns {Promise<Workbook>}
 */
export const getWorkbook = async (blob) => {
  const bufferArray = await readFileAsArrayBuffer(blob);
  const workbook = XLSX.read(bufferArray, { type: 'buffer', bookDeps: true });
  return new Workbook(workbook);
};

/**
 * @param {File} file
 * @returns {Promise<Workbook>}
 */
export const getWorkbookFromFile = async (file) => {
  const workbook = XLSX.read(file, { bookDeps: true });
  return new Workbook(workbook);
};
